import React, { useMemo } from 'react';

import { Typography, Grid } from '@gogame/components';
import { AmountFormatter, NumberValueFormatter } from '@gogame/intl-ts';

const MonthlyTotal = ({ monthly = [], budgetAmount = 0, currency }) => {
  const monthlyTotal = useMemo(() => {
    return monthly.reduce((total, { amount }) => total + amount, 0);
  }, [monthly]);

  const monthlyDiff = monthlyTotal - budgetAmount;
  return (
    <Grid container>
      <Typography variant={'caption'} color={'text.secondary'}>
        Total:&nbsp;
        <AmountFormatter amount={monthlyTotal} currencyCode={currency} />
        {monthlyDiff !== 0 ? <span>&nbsp;-&nbsp;</span> : null}
      </Typography>
      {monthlyDiff !== 0 ? (
        <Typography variant={'caption'} color={'error.main'}>
          monthly totals are&nbsp;
          <NumberValueFormatter.Currency
            value={Math.abs(monthlyDiff)}
            currency={currency}
          />
          &nbsp;
          {monthlyDiff < 0 ? 'lower' : 'higher '} than the total budget
        </Typography>
      ) : null}
    </Grid>
  );
};

export default MonthlyTotal;
